import { getIncubatorIconLayout } from '../../utils/incubatorLayouts';

const PLATE = 4;
const PLATE_GAP = 1;
const CHAMBER_PAD = 1.5;
const CHAMBER_GAP = 2;
const STROKE = 1;

export type IncubatorIconProps = {
  incubatorType: string;
  height?: number;
  className?: string;
};

export const IncubatorIcon = ({
  incubatorType,
  height = 24,
  className,
}: IncubatorIconProps) => {
  const layout = getIncubatorIconLayout(incubatorType);
  if (!layout) return null;

  const { chambersAcross, chambersDown, chamberRows, chamberCols } = layout;
  const chamberWidth =
    chamberCols * PLATE + (chamberCols - 1) * PLATE_GAP + CHAMBER_PAD * 2;
  const chamberHeight =
    chamberRows * PLATE + (chamberRows - 1) * PLATE_GAP + CHAMBER_PAD * 2;
  const width =
    chambersAcross * chamberWidth + (chambersAcross - 1) * CHAMBER_GAP + STROKE;
  const totalHeight =
    chambersDown * chamberHeight + (chambersDown - 1) * CHAMBER_GAP + STROKE;

  const chambers = Array.from(
    { length: chambersAcross * chambersDown },
    (_, i) => ({
      x: STROKE / 2 + (i % chambersAcross) * (chamberWidth + CHAMBER_GAP),
      y:
        STROKE / 2 +
        Math.floor(i / chambersAcross) * (chamberHeight + CHAMBER_GAP),
    }),
  );
  const plates = Array.from({ length: chamberRows * chamberCols }, (_, i) => ({
    dx: CHAMBER_PAD + (i % chamberCols) * (PLATE + PLATE_GAP),
    dy: CHAMBER_PAD + Math.floor(i / chamberCols) * (PLATE + PLATE_GAP),
  }));

  return (
    <svg
      role="img"
      aria-label={incubatorType}
      data-testid={`incubator-icon-${incubatorType}`}
      viewBox={`0 0 ${width} ${totalHeight}`}
      height={height}
      width={Math.round(height * 1.5)}
      className={`flex-shrink-0 text-gray-500 ${className ?? ''}`}
    >
      {chambers.map((c, ci) => (
        <g key={ci} transform={`translate(${c.x} ${c.y})`}>
          <rect
            width={chamberWidth}
            height={chamberHeight}
            rx={1}
            fill="none"
            stroke="currentColor"
            strokeWidth={STROKE}
            vectorEffect="non-scaling-stroke"
          />
          {plates.map((p, pi) => (
            <rect
              key={pi}
              x={p.dx}
              y={p.dy}
              width={PLATE}
              height={PLATE}
              rx={PLATE / 2}
              fill="currentColor"
              opacity={0.45}
            />
          ))}
        </g>
      ))}
    </svg>
  );
};
